import { useDispatch } from 'react-redux';
import {
  postCrmEvent,
  postEventBuyButtonClicked,
  postEventBuyStep,
} from '../../store/actions/crmEvent/crmEventActions';

export const useBuyButtonEvent = () => {
  const dispatch = useDispatch();

  return (buttonType, account, productCode) => {
    dispatch(
      postEventBuyButtonClicked({
        accountUid: account?.AccountUid,
        buttonType,
        productCode,
      }),
    );
  };
};

export const useBuyFlowStepNameEvent = () => {
  const dispatch = useDispatch();
  return (account, stepName, product, orderType) => {
    dispatch(
      postEventBuyStep({
        accountUid: account?.AccountUid,
        data: {
          StepName: stepName,
          ItemProductCode: product?.ProductCode,
          AccountType: account?.AccountType,
          OrderType: orderType,
        },
      }),
    );
  };
};

export const useCrmEvent = () => {
  const dispatch = useDispatch();
  return (account, eventType, additionalData = {}) => {
    const formattedData = Object.entries(additionalData).map(
      ([key, value]) => ({
        key,
        value: String(value),
      }),
    );

    dispatch(
      postCrmEvent({
        accountUid: account?.AccountUid,
        data: {
          EventType: eventType,
          Data: formattedData,
        },
      }),
    );
  };
};
